import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetBoardQueueGroupsRequestType,
  GetBoardQueueGroupsResponseType,
} from '../types';

export const getBoardQueueGroups = async ({
  pathParams: { organisationId, boardId },
}: GetBoardQueueGroupsRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/queue/groups`;

  const { data } =
    await apiAuthClient.get<GetBoardQueueGroupsResponseType>(url);

  return {
    data: data.data,
  };
};
